export var META_TAG_ENUMS;
(function (META_TAG_ENUMS) {
  META_TAG_ENUMS["BUS_EVENT"] = "MetaTagBusEvent";
  META_TAG_ENUMS["JSON_LD_EVENT"] = "jsonLdTrigger";
  META_TAG_ENUMS["SCRIPT_SELECTOR_ID"] = "js-metatag-json-script-component";
  META_TAG_ENUMS["SCRIPT_TYPE"] = "application/ld+json";
  META_TAG_ENUMS["INJECT_POSITION"] = "afterbegin";
  META_TAG_ENUMS["SCRIPT_TAG"] = "script";
  META_TAG_ENUMS["SCRIPT_HEAD_ID"] = "jsonld_";
})(META_TAG_ENUMS || (META_TAG_ENUMS = {}));